import React, { useCallback } from "react";
import CustomColorPicker from "../../../../components/shared/CustomColorPicker";
import { WATERMARK_COLOR_PRESETS } from "./watermarkSettings";
import "./WatermarkColorMenu.css";

/** Preset swatches + custom picker body (used inside left-panel overlay). */
const WatermarkColorPickerBody = ({
  color = "#FFFFFF",
  onChange = () => {},
  onClose = () => {},
  showRemoveColor = false,
  canRemoveColor = false,
  onRemoveColor = () => {},
}) => {
  const activeHex = String(color || "#FFFFFF").toUpperCase();

  // CustomColorPicker echoes onChange when syncing from props — skip no-ops so
  // opening the panel does not auto-apply a tint on an untinted logo.
  const commitColor = useCallback(
    (next) => {
      const hex = String(next || "").toUpperCase();
      if (!hex || hex === activeHex) return;
      onChange(next);
    },
    [activeHex, onChange]
  );

  return (
    <div className="wmc-color-menu__body wmc-color-menu__body--embedded">
      <div
        className="wmc-color-menu__presets"
        role="listbox"
        aria-label="Popular watermark colors"
      >
        {WATERMARK_COLOR_PRESETS.map((hex) => {
          const selected = activeHex === hex.toUpperCase();
          const light =
            hex.toUpperCase() === "#FFFFFF" ||
            hex.toUpperCase() === "#F5F5F5" ||
            hex.toUpperCase() === "#E0E0E0";
          return (
            <button
              key={hex}
              type="button"
              role="option"
              aria-selected={selected}
              title={hex}
              className={`wmc-color-menu__swatch${selected ? " is-active" : ""}${
                light ? " is-light" : ""
              }`}
              style={{ background: hex }}
              onClick={() => onChange(hex)}
            />
          );
        })}
      </div>

      <div className="wmc-color-menu__divider" aria-hidden="true" />

      <CustomColorPicker
        embedded
        isOpen
        showPopularPalette={false}
        showDragHeader={false}
        showApplyButton={false}
        color={color}
        onChange={commitColor}
        onClose={() => {}}
      />

      <div className="wmc-color-menu__footer">
        <button
          type="button"
          className="wmc-color-menu__close"
          onClick={onClose}
        >
          Close
        </button>
        {showRemoveColor ? (
          <button
            type="button"
            className="wmc-color-menu__remove"
            disabled={!canRemoveColor}
            onClick={() => onRemoveColor()}
          >
            Remove color
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default WatermarkColorPickerBody;
